import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// i18n
import './i18n';
// Styles
import './styles/fonts.css';
import './styles/reset.css';
import './styles/theme.css';
import './styles/utils.css';
import '@zolteam/zol-admin-ui/dist/style.css';
// import 'react-toastify/dist/ReactToastify.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
